import React, { useState,useEffect } from 'react';
import { toast } from 'react-toastify';
import {format } from 'date-fns';
import { getDefaultReviewList,getSingleReviewTemplateDetail,searchAirbnbReview } from "../../../../utils/reviewApi";
import { getSingleWidgetDetail } from "../../../../staticWidgets/utils/CommonWidgetApi";
import RatingStars from "../../../../components/RatingStars";

const FloatingWidget = ({selectedLayout,isTemplateId, widgetId,reviewTabData}) => {
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  const [expandedReviewId, setExpandedReviewId] = useState(null);

  // Default values for the reviewTabData
  const {
      is_website_frontend,
      business_name,
      style_background_color,
      header_is_widget_title,
      header_title,
      header_caption,
      setting_rating_format,
      style_widget_title_color,
      style_widget_title_fonts_title_size,
      style_widget_title_caption_color,
      style_widget_title_fonts_caption_size,
      style_header_background_color,
      header_is_show_header,
      header_write_reviews_button,
      header_source_icon,
      header_rating,
      header_number_of_reviews,
      style_header_text_color,
      style_header_write_review_background_color,
      style_header_write_review_text_color,
      header_write_review_button_type,
      style_rating_stars_color,
      style_load_more_button_color,
      style_load_more_button_text_color,
  } = reviewTabData || {};

  //Handle when clicking "Read More"
  const handleReadMoreClick = (review) => {
    setExpandedReviewId(prev =>
      prev === review.id ? null : review.id
    );
  };

  //Handle Main Popup
  const togglePopup = () => {
      setShowPopup(!showPopup);
  };

  // Load More function
  const handleLoadMore = () => {
      setVisibleCount((prevCount) => prevCount + 5);
  };

  // Fetching Review data
  useEffect(() => {
      const fetchData = async () => {
          setLoading(true);
          try {
              let result;
              if (isTemplateId) {
                  result = await getSingleReviewTemplateDetail(isTemplateId);
              } else if (widgetId) {
                  result = await getSingleWidgetDetail(widgetId);
              } else if (business_name) {
                const payload = { business_name: business_name };
                result = await searchAirbnbReview(payload);
              } else {
                  let app_type = 'Airbnb_Review';
                  result = await getDefaultReviewList(app_type);
              }
              setApiData(result);
          } catch (error) {
              toast.warning(error.message);
          } finally {
              setLoading(false); 
          }
      };

      fetchData();
  }, [isTemplateId, widgetId, business_name]);

  return (
    <>
      <div className={`upgadeify-review-template-widget ${loading ? '': 'upgadeify-floating-style'} ${showPopup ? 'main-popup-open' : ''} ${is_website_frontend}`}>
        {/* Loader and No Api Data Handling */}
        {loading ? (
          <div className="loader-container">
              <div className="spinner"></div>
              <p>Loading please wait...</p>
          </div>
        ) : apiData?.status === true ? (
        <>
        <div className='upgadeify-badge-style-header' onClick={togglePopup}>
          <div className='upgadeify-badge-header-title'>
               <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="injected-svg"><path fill="#FF385C" fill-rule="evenodd" d="M21.157 16.214c-.101-.24-.203-.5-.304-.72-.162-.36-.325-.701-.467-1.021l-.02-.02a208.116 208.116 0 0 0-4.488-9.05l-.061-.12c-.162-.3-.325-.62-.488-.94-.203-.36-.405-.741-.73-1.102A3.298 3.298 0 0 0 12.02 2c-1.015 0-1.929.44-2.6 1.202-.304.36-.527.74-.73 1.1-.163.32-.325.641-.487.942l-.062.12a233.985 233.985 0 0 0-4.487 9.048l-.02.04c-.142.32-.305.661-.467 1.022-.102.22-.203.46-.305.72-.264.74-.345 1.442-.243 2.162a4.264 4.264 0 0 0 2.639 3.323A4.208 4.208 0 0 0 6.903 22a5.422 5.422 0 0 0 2.559-.72c.832-.461 1.624-1.122 2.517-2.083.894.961 1.706 1.622 2.518 2.082a5.42 5.42 0 0 0 2.559.721c.568 0 1.137-.1 1.644-.32a4.257 4.257 0 0 0 2.64-3.324c.162-.7.082-1.4-.183-2.142ZM12 17.255c-1.096-1.361-1.806-2.642-2.05-3.723-.102-.461-.122-.861-.062-1.222.041-.32.163-.6.325-.84.386-.541 1.036-.881 1.787-.881.752 0 1.422.32 1.787.88.163.24.285.521.325.841.061.36.041.78-.06 1.222-.244 1.06-.955 2.342-2.052 3.723Zm8.102.941a2.98 2.98 0 0 1-1.847 2.342 3.11 3.11 0 0 1-1.544.2 4.02 4.02 0 0 1-1.543-.52c-.73-.4-1.462-1.02-2.315-1.942 1.34-1.622 2.153-3.103 2.457-4.424a4.95 4.95 0 0 0 .102-1.702 3.24 3.24 0 0 0-.548-1.361c-.63-.901-1.685-1.422-2.864-1.422-1.177 0-2.233.541-2.862 1.422-.285.4-.468.86-.549 1.361a4.092 4.092 0 0 0 .102 1.702c.304 1.321 1.137 2.823 2.457 4.444-.833.921-1.584 1.542-2.315 1.942-.528.3-1.036.46-1.543.52a3.297 3.297 0 0 1-1.543-.2 2.983 2.983 0 0 1-1.849-2.342c-.06-.5-.02-1 .183-1.562.062-.2.163-.4.265-.64.142-.32.304-.66.466-1l.02-.041A217.999 217.999 0 0 1 9.3 5.984l.061-.12c.162-.3.325-.62.487-.921.163-.32.346-.62.569-.88a2.134 2.134 0 0 1 1.624-.742c.63 0 1.198.261 1.625.741.223.26.406.56.568.881.163.3.325.62.488.921l.06.12a263.89 263.89 0 0 1 4.447 9.01v.02c.162.32.305.68.467 1 .102.24.203.44.264.64.163.52.224 1.022.142 1.542Z" clip-rule="evenodd"></path></svg>
            <div className='upgadeify-badge-reviews-header-title-text'>Airbnb Rating</div>
          </div>
          <div className='upgadeify-airbnb-reviews-header-rating'>
            <div className="upgadeify-airbnb-reviews-header-rating-text">{setting_rating_format === '4.9' ? Number(apiData.data.average_rating).toFixed(1) : Number(apiData.data.average_rating).toFixed(2) }</div>
            <div className="upgadeify-airbnb-reviews-item-rating">
              <RatingStars average_rating={apiData.data.average_rating} newColor={style_rating_stars_color} />
            </div>
          </div>
          <div className="upgadeify-badge-reviews-readmore">
            Read our { apiData.data.total_reviews } reviews
          </div>
        </div>
      </>
        ) : (
          <div className="no-inner-result-found">
            <p>No Airbnb reviews found please check the product number.</p>
          </div>
        )}
    </div>

    {showPopup && (
      <div className="upgadeify-badge-fixed-style">
        <div className='upgadeify-badge-style-inner' style={{backgroundColor: style_background_color}}>
            <button className="upgadeify-badge-fixed-style-close" onClick={togglePopup}>X</button>
          {Number(header_is_widget_title) === 1 && (
                <>
                <div className="upgadeify-badge-fixed-style-title">
                    <h2 style={{ color: style_widget_title_color,fontSize: style_widget_title_fonts_title_size }}>{header_title || ""}</h2>
                    <h2 style={{ color: style_widget_title_caption_color,fontSize: style_widget_title_fonts_caption_size }}>{header_caption || ""}</h2>
                </div>
              </>
            )}
            {Number(header_is_show_header) === 1 &&
                (Number(header_source_icon) === 1 ||
                    Number(header_rating) === 1 ||
                    Number(header_number_of_reviews) === 1 ||
                    Number(header_write_reviews_button) === 1) && (
                <div className="upgadeify-badge-fixed-style-header" style={{ backgroundColor: style_header_background_color,}}>
               
                    <div className='upgadeify-airbnb-reviews-header-left'>
                      {Number(header_source_icon) === 1 && (
                      <div className='upgadeify-airbnb-reviews-header-title'>
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 91 36" className="injected-svg"><path fill="#FF385C" fill-rule="evenodd" d="M47.96 11.035a1.83 1.83 0 0 1-1.848 1.822 1.832 1.832 0 0 1-1.848-1.822c0-1.009.796-1.821 1.848-1.821 1.052.027 1.848.84 1.848 1.821Zm-7.619 3.672v.448s-.881-1.12-2.757-1.12c-3.099 0-5.515 2.325-5.515 5.548 0 3.196 2.388 5.55 5.515 5.55 1.905 0 2.757-1.15 2.757-1.15v.478c0 .224.171.392.398.392h2.303V14.314h-2.303a.404.404 0 0 0-.398.393Zm0 6.755c-.426.616-1.28 1.149-2.303 1.149-1.819 0-3.211-1.122-3.211-3.028 0-1.905 1.392-3.026 3.212-3.026.995 0 1.904.56 2.302 1.149v3.756Zm4.407 3.39h2.729V14.314h-2.73v10.538Zm40.765-10.818c-1.876 0-2.757 1.121-2.757 1.121V9.241h-2.73v15.612h2.303a.404.404 0 0 0 .398-.392v-.477s.881 1.15 2.758 1.15c3.099 0 5.515-2.355 5.515-5.55 0-3.196-2.416-5.55-5.487-5.55Zm-.454 8.548c-1.053 0-1.877-.532-2.303-1.149v-3.755c.426-.561 1.335-1.149 2.303-1.149 1.819 0 3.212 1.12 3.212 3.027 0 1.906-1.393 3.026-3.212 3.026Zm-6.454-3.979v6.278h-2.729v-5.97c0-1.738-.569-2.438-2.104-2.438-.824 0-1.677.42-2.217 1.036v7.344h-2.73V14.314h2.161c.228 0 .398.197.398.393v.448c.797-.812 1.848-1.12 2.9-1.12 1.194 0 2.189.335 2.985 1.008.967.785 1.336 1.794 1.336 3.56Zm-16.403-4.569c-1.876 0-2.757 1.121-2.757 1.121V9.241h-2.73v15.612h2.303a.405.405 0 0 0 .398-.392v-.477s.882 1.15 2.758 1.15c3.099 0 5.515-2.355 5.515-5.55.029-3.196-2.388-5.55-5.487-5.55Zm-.455 8.548c-1.051 0-1.876-.532-2.302-1.149v-3.755c.426-.561 1.336-1.149 2.302-1.149 1.82 0 3.213 1.12 3.213 3.027 0 1.906-1.393 3.026-3.213 3.026Zm-7.39-8.548c.824 0 1.25.14 1.25.14v2.495s-2.274-.757-3.695.84v7.372h-2.73V14.314h2.303c.228 0 .398.197.398.393v.448c.512-.588 1.62-1.12 2.473-1.12ZM26.013 23.9c-.142-.337-.285-.7-.427-1.01-.227-.503-.455-.98-.654-1.428l-.028-.029a291.587 291.587 0 0 0-6.282-12.668l-.086-.168c-.227-.42-.454-.87-.682-1.317-.285-.505-.569-1.038-1.024-1.542A4.617 4.617 0 0 0 13.221 4c-1.42 0-2.7.617-3.638 1.682-.427.504-.74 1.037-1.024 1.542-.228.448-.455.896-.682 1.317l-.086.168c-2.188 4.204-4.32 8.464-6.282 12.668l-.028.056c-.2.449-.427.925-.654 1.43-.143.308-.285.644-.427 1.009-.37 1.037-.483 2.018-.34 3.027a5.97 5.97 0 0 0 3.694 4.652c.74.309 1.508.449 2.303.449a7.589 7.589 0 0 0 3.583-1.009c1.165-.645 2.273-1.57 3.524-2.915 1.25 1.345 2.388 2.27 3.525 2.915A7.585 7.585 0 0 0 20.271 32c.796 0 1.592-.14 2.303-.449A5.96 5.96 0 0 0 26.27 26.9c.227-.982.114-1.962-.256-3Zm-12.821 1.457c-1.536-1.906-2.53-3.699-2.871-5.213-.142-.644-.171-1.205-.086-1.71a2.7 2.7 0 0 1 .455-1.176c.54-.758 1.45-1.234 2.502-1.234 1.052 0 1.99.449 2.501 1.234.228.335.398.729.455 1.176.085.505.057 1.093-.085 1.71-.341 1.486-1.336 3.28-2.871 5.213Zm11.342 1.318c-.199 1.457-1.193 2.718-2.587 3.279-.682.28-1.42.364-2.16.28a5.63 5.63 0 0 1-2.16-.729c-1.024-.56-2.047-1.429-3.241-2.718 1.876-2.27 3.013-4.345 3.44-6.194a6.939 6.939 0 0 0 .142-2.383 4.525 4.525 0 0 0-.768-1.906c-.88-1.261-2.36-1.99-4.008-1.99-1.649 0-3.127.758-4.009 1.99a4.504 4.504 0 0 0-.767 1.907 5.728 5.728 0 0 0 .142 2.382c.426 1.85 1.592 3.952 3.44 6.222-1.166 1.289-2.217 2.158-3.24 2.719-.74.42-1.45.645-2.161.728a4.617 4.617 0 0 1-2.16-.28c-1.394-.56-2.39-1.822-2.588-3.28a4.585 4.585 0 0 1 .256-2.186c.086-.28.227-.56.37-.896.199-.449.426-.925.653-1.402l.029-.056A305.11 305.11 0 0 1 9.412 9.578l.085-.168c.228-.421.455-.869.683-1.29.227-.448.483-.869.795-1.233.597-.672 1.393-1.037 2.274-1.037.882 0 1.678.365 2.275 1.037.312.364.568.785.796 1.233.227.421.454.869.682 1.29l.085.168a369.507 369.507 0 0 1 6.226 12.613v.027c.227.449.426.953.654 1.402.142.336.284.616.37.896.227.729.312 1.43.198 2.159Z" clip-rule="evenodd"></path></svg>
                          <div className='upgadeify-airbnb-reviews-header-title-text' style={{color: style_header_text_color,}}>Reviews</div>
                      </div>
                      )}
                      <div className='upgadeify-airbnb-reviews-header-rating'>
                          {Number(header_rating) === 1 && (
                          <>
                              <div className="upgadeify-airbnb-reviews-header-rating-text" style={{color: style_header_text_color,}}>{setting_rating_format === '4.9' ? Number(apiData.data.average_rating).toFixed(1) : Number(apiData.data.average_rating).toFixed(2) }</div>
                              <div className="upgadeify-airbnb-reviews-item-rating">
                                  <RatingStars average_rating={apiData.data.average_rating} newColor={style_rating_stars_color} />
                              </div>
                          </>
                          )}
                          {Number(header_number_of_reviews) === 1 && (
                              <span className="upgadeify-airbnb-reviews-header-number-of-reviews-text">({apiData.data.total_reviews})</span>
                          )}
                      </div>
                </div>
                {Number(header_write_reviews_button) === 1 && (
                    <div className='upgadeify-airbnb-reviews-header-right'>
                        <a
                            href={apiData?.data?.google_url?.startsWith('http') ? apiData.data.google_url : `https://${apiData.data.google_url}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className='upgadeify-airbnb-reviews-header-button'
                            style={{color: style_header_write_review_text_color,backgroundColor: style_header_write_review_background_color,fontSize: header_write_review_button_type}}>Review us on Airbnb
                        </a>
                    </div>
                )}
            </div>
          )}
          {/* Reviews List */}
          {apiData.data.review_list.slice(0, visibleCount).map((review) => (
              <ReviewLoopItem key={review.id} review={review} handleReadMoreClick={handleReadMoreClick} reviewTabData={reviewTabData} expandedReviewId={expandedReviewId}/>
          ))}
          {/* Load More Button  */}
          {visibleCount < apiData.data.review_list.length && (
            <div className="load-more-button">
                <button onClick={handleLoadMore} style={{backgroundColor: style_load_more_button_color,color: style_load_more_button_text_color}}>Load More</button>
            </div>
          )}
         </div>   
      </div>
      )}
    </>
  );
};

const ReviewLoopItem = ({ review, handleReadMoreClick, reviewTabData, expandedReviewId }) => (
    <>
        <div className="upgadeify-airbnb-reviews">
            <div className='upgadeify-airbnb-reviews-item' style={{ padding: `${reviewTabData.layout_item_spacing}px`, backgroundColor: reviewTabData.style_review_background_color,}}>
               <div className='upgadeify-airbnb-reviews-head'>
                {Number(reviewTabData.review_is_show_reviewer_picture) === 1 && (
                    <div className="upgadeify-airbnb-reviews-item-image">
                        {review.image ? (
                            <img src={review.image} alt="Review" />
                        ) : (
                            <div className="fallback-avatar">
                                {review.name.charAt(0)}
                            </div>
                        )}

                          

                    </div>
                )}
                <div className='upgadeify-airbnb-reviews-item-name'>
                    {Number(reviewTabData.review_is_show_reviewer_name) === 1 && (
                        Number(reviewTabData.setting_is_enable_external_links) === 1 && review.author_url ? ( 
                            <a
                                href={review.author_url} 
                                target={Number(reviewTabData.setting_is_open_links_in_new_tab) === 1 ? "_blank" : "_self"}
                                rel={Number(reviewTabData.setting_is_open_links_in_new_tab) === 1 ? "noopener noreferrer" : undefined}
                                style={{ color: reviewTabData.style_review_reviewer_name_color }}
                            >
                                <span className="upgadeify-airbnb-reviews-item-name-text" style={{ color: reviewTabData.style_review_reviewer_name_color }}>{review.name}</span>
                            </a>
                        ) : (
                            <span className="upgadeify-airbnb-reviews-item-name-text" style={{ color: reviewTabData.style_review_reviewer_name_color }}>
                                {review.name}
                            </span>
                        )
                    )}

                    {Number(reviewTabData.review_is_show_verified_badge) === 1 && (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" className="review-verified-badge-icon" aria-hidden="true">
                            <path fill={reviewTabData.style_review_verified_badge_color} d="M6.757.236a.35.35 0 0 1 .486 0l1.106 1.07a.35.35 0 0 0 .329.089l1.493-.375a.35.35 0 0 1 .422.244l.422 1.48a.35.35 0 0 0 .24.24l1.481.423a.35.35 0 0 1 .244.422l-.375 1.493a.35.35 0 0 0 .088.329l1.071 1.106a.35.35 0 0 1 0 .486l-1.07 1.106a.35.35 0 0 0-.089.329l.375 1.493a.35.35 0 0 1-.244.422l-1.48.422a.35.35 0 0 0-.24.24l-.423 1.481a.35.35 0 0 1-.422.244l-1.493-.375a.35.35 0 0 0-.329.088l-1.106 1.071a.35.35 0 0 1-.486 0l-1.106-1.07a.35.35 0 0 0-.329-.089l-1.493.375a.35.35 0 0 1-.422-.244l-.422-1.48a.35.35 0 0 0-.24-.24l-1.481-.423a.35.35 0 0 1-.244-.422l.375-1.493a.35.35 0 0 0-.088-.329L.236 7.243a.35.35 0 0 1 0-.486l1.07-1.106a.35.35 0 0 0 .089-.329L1.02 3.829a.35.35 0 0 1 .244-.422l1.48-.422a.35.35 0 0 0 .24-.24l.423-1.481a.35.35 0 0 1 .422-.244l1.493.375a.35.35 0 0 0 .329-.088L6.757.236Z"></path><path fill="#fff" fill-rule="evenodd" d="M9.065 4.85a.644.644 0 0 1 .899 0 .615.615 0 0 1 .053.823l-.053.059L6.48 9.15a.645.645 0 0 1-.84.052l-.06-.052-1.66-1.527a.616.616 0 0 1 0-.882.645.645 0 0 1 .84-.052l.06.052 1.21 1.086 3.034-2.978Z" clip-rule="evenodd"></path>
                        </svg>
                    )}

                    <span className="upgadeify-airbnb-reviews-item-date"> 
                        {Number(reviewTabData.review_is_show_date) === 1 && (
                            <span style={{color: reviewTabData.style_review_date_color,}}>{review.review_date ? format(new Date(review.review_date), 'yyyy-MM-dd') : ''}</span>
                        )}
                    </span>
                </div>
               </div>
                <div className="upgadeify-airbnb-reviews-item-content">
                    {Number(reviewTabData.review_is_show_rating) === 1 && (
                        <span className="upgadeify-airbnb-reviews-item-rating" style={{ fontSize: reviewTabData.style_review_rating_size }}>
                            <RatingStars average_rating={review.rating} newColor={reviewTabData.style_rating_stars_color}/>
                        </span>
                    )}
                    <div className="upgadeify-airbnb-reviews-item-text" style={{color: `${reviewTabData.style_review_text_color}`,fontSize: reviewTabData.style_review_text_font_size}}>
                        {expandedReviewId === review.id ? review.description: review.description.length > 50
                            ? `${review.description.slice(0, 50)}...`
                            : review.description
                        }
                    </div>
                    {review.description.length > 50 && (
                      <div className="upgadeify-airbnb-reviews-readmore" onClick={() => handleReadMoreClick(review)}
                        style={{
                          color: reviewTabData.style_read_more_color,
                          fontSize: reviewTabData.style_review_text_font_size
                        }}
                      >
                        {expandedReviewId === review.id ? 'Read less' : 'Read more'}
                      </div>
                    )}

                    {Number(reviewTabData.review_is_show_review_source) === 1 && (  
                        <div className='upgadeify-airbnb-reviews-item-image-badge'>
                           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="injected-svg" ><path fill="#FF385C" fill-rule="evenodd" d="M21.157 16.214c-.101-.24-.203-.5-.304-.72-.162-.36-.325-.701-.467-1.021l-.02-.02a208.116 208.116 0 0 0-4.488-9.05l-.061-.12c-.162-.3-.325-.62-.488-.94-.203-.36-.405-.741-.73-1.102A3.298 3.298 0 0 0 12.02 2c-1.015 0-1.929.44-2.6 1.202-.304.36-.527.74-.73 1.1-.163.32-.325.641-.487.942l-.062.12a233.985 233.985 0 0 0-4.487 9.048l-.02.04c-.142.32-.305.661-.467 1.022-.102.22-.203.46-.305.72-.264.74-.345 1.442-.243 2.162a4.264 4.264 0 0 0 2.639 3.323A4.208 4.208 0 0 0 6.903 22a5.422 5.422 0 0 0 2.559-.72c.832-.461 1.624-1.122 2.517-2.083.894.961 1.706 1.622 2.518 2.082a5.42 5.42 0 0 0 2.559.721c.568 0 1.137-.1 1.644-.32a4.257 4.257 0 0 0 2.64-3.324c.162-.7.082-1.4-.183-2.142ZM12 17.255c-1.096-1.361-1.806-2.642-2.05-3.723-.102-.461-.122-.861-.062-1.222.041-.32.163-.6.325-.84.386-.541 1.036-.881 1.787-.881.752 0 1.422.32 1.787.88.163.24.285.521.325.841.061.36.041.78-.06 1.222-.244 1.06-.955 2.342-2.052 3.723Zm8.102.941a2.98 2.98 0 0 1-1.847 2.342 3.11 3.11 0 0 1-1.544.2 4.02 4.02 0 0 1-1.543-.52c-.73-.4-1.462-1.02-2.315-1.942 1.34-1.622 2.153-3.103 2.457-4.424a4.95 4.95 0 0 0 .102-1.702 3.24 3.24 0 0 0-.548-1.361c-.63-.901-1.685-1.422-2.864-1.422-1.177 0-2.233.541-2.862 1.422-.285.4-.468.86-.549 1.361a4.092 4.092 0 0 0 .102 1.702c.304 1.321 1.137 2.823 2.457 4.444-.833.921-1.584 1.542-2.315 1.942-.528.3-1.036.46-1.543.52a3.297 3.297 0 0 1-1.543-.2 2.983 2.983 0 0 1-1.849-2.342c-.06-.5-.02-1 .183-1.562.062-.2.163-.4.265-.64.142-.32.304-.66.466-1l.02-.041A217.999 217.999 0 0 1 9.3 5.984l.061-.12c.162-.3.325-.62.487-.921.163-.32.346-.62.569-.88a2.134 2.134 0 0 1 1.624-.742c.63 0 1.198.261 1.625.741.223.26.406.56.568.881.163.3.325.62.488.921l.06.12a263.89 263.89 0 0 1 4.447 9.01v.02c.162.32.305.68.467 1 .102.24.203.44.264.64.163.52.224 1.022.142 1.542Z" clip-rule="evenodd"></path></svg>
                            Posted On   
                            <> <a href={`https://www.airbnb.com`} target="blank">Airbnb</a></> 
                        </div> 
                    )} 
                </div>
            </div>
        </div>
    </>
);

export default FloatingWidget;
